import { render } from "./PjList.vue?vue&type=template&id=03d27881&scoped=true"
import script from "./PjList.vue?vue&type=script&lang=js"
export * from "./PjList.vue?vue&type=script&lang=js"

import "./PjList.vue?vue&type=style&index=0&id=03d27881&lang=css"
import "./PjList.vue?vue&type=style&index=1&id=03d27881&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d27881"]])

export default __exports__